import { render } from "./Max.vue?vue&type=template&id=34b8d3df"
import script from "./Max.vue?vue&type=script&lang=js"
export * from "./Max.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__